import React, { useState } from 'react';
import Table from '../../../components/Table'
import { MenuComportamento } from '../../../components/Menus'
import { Badge } from 'reactstrap'
import { labelSituacao } from './constants'

export default ({ scripts, pageProperties, onTableChange, onToggleStatus, notify, ...props }) => {

    const [columns] = useState([
        {
            dataField: 'acoes',
            formatter: (cell, row) => acoesFormatter(cell, row)
        },
        {
            dataField: "titulo",
            text: 'Titulo',
        },
        {
            dataField: "situacao",
            text: 'Situação',
            formatter: (cell) => cell ? <Badge color="info">{labelSituacao(cell)}</Badge> : null
        },
        {
            dataField: "perfil_negocio",
            text: 'Perfil de Negócio',
            formatter: (cell, row) => row.perfilNegocio?.nome || row.perfil_negocio?.nome || ''
        },
        {
            dataField: "tags",
            text: 'Tags',
            formatter: (cell) => tagsFormatter(cell)
        },
        {
            dataField: "deleted_at",
            text: 'Status',
            formatter: (cell) => {
                return cell ? <Badge color="danger">Inativo</Badge> : <Badge color="success">Ativo</Badge>
            }
        },
    ])

    function goToEdit(id) {
        props.history.push(`/admin/scripts-venda/${new Number(id)}/edit`)
    }

    const tagsFormatter = (cell) => {
        if (!cell) return null
        const tags = cell.split(',')
        const limit = 3
        const visibleTags = tags.slice(0, limit)
        const hiddenCount = tags.length - limit

        return (
            <>
                {visibleTags.map((tag, i) => (
                    <Badge key={i} color="primary" className="mr-1">{tag.trim()}</Badge>
                ))}
                {hiddenCount > 0 && (
                    <Badge color="secondary" className="mr-1">+{hiddenCount}</Badge>
                )}
            </>
        )
    }

    const acoesFormatter = (cell, row) => {
        const isInactive = !!row.deleted_at;
        return (
            <MenuComportamento
                actions={[
                    {
                        label: 'Alterar',
                        icons: 'far fa-edit',
                        onClick: () => goToEdit(row.id)
                    },
                    {
                        label: isInactive ? 'Reativar' : 'Inativar',
                        icons: isInactive ? 'fas fa-check' : 'fas fa-ban',
                        onClick: () => onToggleStatus(row)
                    }
                ]}
            />
        )
    }

    return (
        <>
            <Table
                columns={columns}
                data={scripts}
                classes="table-sm table-v-middle"
                condensed
                pageProperties={pageProperties}
                onTableChange={onTableChange}
            />
        </>
    );
}
